import { APP_THEME } from 'config'
const LANG = process.env.REACT_APP_LOCALE === 'en' ? 'en' : 'fi';
const localeConfig = require(`../../../public/json/localizations-${LANG}.json`);
const seoStrings = localeConfig.localizations[LANG].seo;


const baseSiteName = APP_THEME === 'goplaygolf' ? seoStrings.BASE.title_goplaygolf : seoStrings.BASE.title;
const baseImgUrl = 'https://s3-eu-west-1.amazonaws.com/bt-share/birdietime_share-2.jpg';
const baseDescription = APP_THEME === 'goplaygolf' ? seoStrings.BASE.description_goplaygolf : seoStrings.BASE.description;


const BASE = {
  title: baseSiteName,
  meta: [
    { name: 'description', content: baseDescription },
    { property: 'og:title', content: baseSiteName },
    { property: 'og:description', content: baseDescription },
    { property: 'og:image', content: baseImgUrl },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: localeConfig.settings.locale },
  ]
};

const parseSeoValue = (key) => !!key ? key : undefined;
const constructSeoDataForPage = (pageKey) => {
  const hasAnyData = !!seoStrings[pageKey];
  if(!hasAnyData) return {};

  const title = parseSeoValue(seoStrings[pageKey].title);
  const description = parseSeoValue(seoStrings[pageKey].description);

  const data = {meta:[]};
  if(title) {
    const seoTitle = `${title} | ${baseSiteName}`;
    data.title = seoTitle;
    data.meta.push({ property: 'og:title', content: seoTitle });
  }
  if(description) {
    data.meta.push({ name: 'description', content: description });
    data.meta.push({ property: 'og:description', content: description });
  }
  const pageData = Object.assign([], BASE, data);
  pageData.meta = Object.assign([], BASE.meta, data.meta);

  return pageData;
};

const pageSeoData = {
  home: constructSeoDataForPage('home'),
  search: constructSeoDataForPage('search'),
  contact: constructSeoDataForPage('contact'),
  Course: constructSeoDataForPage('course'),
  Trip: constructSeoDataForPage('trip'),
  Lecture: constructSeoDataForPage('lecture'),
  courses: constructSeoDataForPage('courses'),
  terms: constructSeoDataForPage('terms'),
  pros: constructSeoDataForPage('pros'),
  cookies: constructSeoDataForPage('cookies'),
};

const getSeoForPage = (page_prop, opts) => {
  if (page_prop === 'custom') {
    try {
      const base = Object.assign({}, BASE);
      let _description = opts.description && opts.description.length < 257 ? opts.description : opts.description.substr(0, 256);

      base.title = opts.title + ' | ' + baseSiteName;
      base.meta = [
        {name: 'description', content: _description || baseDescription},
        {property: 'og:title', content: opts.title + ' | ' + baseSiteName},
        {property: 'og:description', content: _description || baseDescription},
        {property: 'og:image', content: opts.image || baseImgUrl},
      ];
      base.meta = Object.assign([], BASE.meta, base.meta);
      return base;
    } catch (e) {
      return BASE;
    }
  } else {
    const pageData = pageSeoData[page_prop];
    if(pageData) {
      return pageData;
    }
    return BASE;
  }
};

export {
  pageSeoData,
  getSeoForPage
}



// WEBPACK FOOTER //
// ./src/modules/seo/index.js